module.exports = __webpack_public_path__ + "static/media/vihreasahko-white.036d5b85.svg";